<template>
  <creation-modal
    class="base-modal"
    title="Edition projet"
    id="projectModal"
    ref="projectModalRef"
  >
    <form>
      <step-component
        :step="1"
        @handleNextStep="handleNextStepAction"
        @handlePreviousStep="hideModal"
        v-if="step === 1"
      >
        <div class="col-6 form-stylizer">
          <b-form-group
            id="clients-group"
            label="Client *"
            label-for="client-input"
          >
            <b-form-select
              id="client-input"
              name="societe"
              v-model="form.client"
              :options="clientList"
              v-validate="'required'"
            >
              <template slot="first">
                <option :value="null" disabled
                  >Veuillez choisir un client</option
                >
              </template>
            </b-form-select>
          </b-form-group>
          <b-form-group
            id="denomination-group"
            label="Dénomination du batiment (*)"
            label-for="denomination-input"
          >
            <b-form-input
              v-model="form.nom"
              name="nom"
              id="denomination-input"
              type="text"
              v-validate="'required'"
            >
            </b-form-input>
          </b-form-group>
        </div>
        <div class="col-6">
          <b-form-group
            id="type-equipement-group"
            label="Type d'équipement"
            label-for="denomination-input"
          >
            <multiselect
              v-model="typeErpValue"
              :options="options"
              :multiple="true"
              group-values="subcategory"
              group-label="category"
              :group-select="true"
              placeholder="Rechercher"
              track-by="nom"
              label="nom"
              :close-on-select="false"
              :show-labels="false"
              @input="formatErp"
            >
            </multiselect>
          </b-form-group>
        </div>
      </step-component>
      <step-component
        :step="2"
        @handlePreviousStep="handlePreviousStepAction"
        @handleNextStep="handleNextStepAction"
        v-if="step === 2"
      >
        <div class="col-12 form-stylizer">
          <b-form-group
            id="statut-group"
            label="Statut"
            label-for="statut-input"
          >
            <b-form-checkbox v-model="form.etat" name="statut-input" switch>
              <span class="statut-etat"
                >({{ form.etat ? "En cours" : "Terminé" }})</span
              >
            </b-form-checkbox>
          </b-form-group>
        </div>
        <div class="col-6 form-stylizer">

          <div
            id="numero-affaire-group"
          >
            <b-form-input
              v-model="form.numeroAffaire"
              id="numero-affaire-input"
              type="text"
              placeholder="Numéro d'affaire"
            >
            </b-form-input>
          </div>
          <div
            id="nom-contact-group"
          >
            <b-form-input
              v-model="form.contactNom"
              id="nom-contact-input"
              type="text"
              placeholder="Nom du contact"
            >
            </b-form-input>
          </div>
          <div
            id="email1-contact-group"
          >
            <b-form-input
              v-model="form.contactEmail"
              id="email1-contact-input"
              type="email"
              placeholder="Email du contact"
            >
            </b-form-input>
          </div>
          <div
            id="tel1-contact-group"
          >
            <b-form-input
              v-model="form.contactTel1"
              id="tel1-contact-input"
              type="text"
              placeholder="Téléphone"
            >
            </b-form-input>
          </div>
          <div
            id="tel2-contact-group"
          >
            <b-form-input
              v-model="form.contactTel2"
              id="tel2-contact-input"
              type="text"
              placeholder="Mobile"
            >
            </b-form-input>
          </div>
        </div>

        <div class="col-6 form-stylizer">
          <div
            id="adresse-client-group"
          >
            <b-form-input
              v-model="form.adresse"
              id="adresse-client-input"
              type="text"
              placeholder="Adresse"
            >
            </b-form-input>
          </div>
          <div
            id="complementAdresse-client-group"
          >
            <b-form-input
              v-model="form.complementAdresse"
              id="complementAdresse-client-input"
              type="text"
              placeholder="Complément d' adresse"
            >
            </b-form-input>
          </div>
          <div class="row">
            <div
              id="code-postal-group"
              class="col-md-4"
            >
              <b-form-input
                v-model="form.codePostal"
                id="code-postal-input"
                type="number"
                name="code-postal-input"
                @keyup="codePostalHandleChange"
                v-validate="'required'"
                placeholder="Code postal *"
              >
              </b-form-input>
            </div>
            <div
              id="departement-group"
              class="col-md-8"
            >
              <b-form-input
                v-model="form.departement"
                id="departement-input"
                type="text"
                readonly
                required
                placeholder="Département *"
              >
              </b-form-input>
            </div>
          </div>
          <div id="ville-group">
            <b-form-input v-model="form.ville" id="ville-input" type="text" placeholder="Ville">
            </b-form-input>
          </div>
          <b-form-group
            id="type-operation-group"
            label="Type d'opération *"
            label-for="type-operation-input"
          >
            <div
              class="custom-control custom-control-inline custom-checkbox"
              v-for="(optionTypeOperation, index) in optionsTypeOperation"
              :key="optionTypeOperation.id"
            >
              <input
                :id="'type-operation-input' + optionTypeOperation.id"
                type="checkbox"
                name="typeOperation"
                autocomplete="off"
                class="custom-control-input"
                v-model="form.typeOperations"
                :value="optionTypeOperation.id"
                v-validate="index === 1 ? 'required' : null"
              />
              <label
                :for="'type-operation-input' + optionTypeOperation.id"
                class="custom-control-label"
                >{{ optionTypeOperation.nom }}</label
              >
            </div>
          </b-form-group>
        </div>
      </step-component>
    </form>
  </creation-modal>
</template>
<script>
import stepComponent from './stepComponent'
import creationModal from '../utils/creationModal'
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    project: {
      type: Array
    },
    editMode: {
      type: Boolean
    }
  },
  components: {
    stepComponent,
    creationModal
  },
  data () {
    return {
      idProject: null,
      form: {
        nom: '',
        typeErp: [],
        client: null,
        contactNom: '',
        contactEmail: '',
        contactTel1: '',
        contactTel2: '',
        adresse: '',
        complementAdresse: '',
        codePostal: '',
        ville: '',
        departement: '',
        societe: this.userSocieteId(),
        typeOperations: [],
        terrainOccupe: false,
        etat: true,
        numeroAffaire: ''
      },
      optionsTypeOperation: [],
      clientList: [],
      selected: 1,
      value: [],
      options: [],
      typeErpValue: [],
      step: 1
    }
  },
  mounted () {
    this.createOptionsErp()
    this.listClient()
    this.getTypeOperationOptions()
  },
  methods: {
    ...mapActions(['setMessage', 'getTypeErp', 'listAdminClient', 'getProjectsByClient', 'setProjectData', 'getDepartement', 'getDepartements', 'getTypeOperation', 'modificationProjet', 'addProject']),
    ...mapGetters(['etat', 'userSocieteId', 'userId', 'client', 'nom', 'typeErp', 'codePostal', 'ville', 'departement', 'contactNom', 'contactEmail', 'contactTel1', 'contactTel2', 'adresse', 'complementAdresse', 'typeOperations', 'code', 'numeroAffaire']),
    getTypeOperationOptions () {
      this.getTypeOperation().then(resp => {
        this.optionsTypeOperation = resp.items
      })
    },
    listClient () {
      this.listAdminClient({ data: this.userSocieteId(), page: 0 }).then((resp) => {
        let options = []
        resp.items.forEach(item => {
          let option = {}
          option.value = item.id
          option.text = item.nom
          options.push(option)
        })
        this.clientList = options
      })
    },
    createOptionsErp () {
      this.getTypeErp().then((resp) => {
        let optionsTest = []
        Object.keys(resp.items).forEach(function (item) {
          let option = {}
          option.category = resp.items[item].categorieErpNom
          option.subcategory = resp.items[item].typeErp
          optionsTest.push(option)
        })
        this.options = optionsTest
      })
    },
    formatErp () {
      this.form.typeErp = this.typeErpValue.map(x => x.id)
    },
    setDataOnForm () {
      this.form.client = this.client().id
      this.form.nom = this.nom()
      this.form.code = this.code()
      this.form.typeErp = this.typeErp().map(x => x.id)
      this.typeErpValue = this.typeErp()
      this.form.codePostal = this.codePostal()
      this.form.ville = this.ville()
      this.form.departement = this.departement()
      this.form.contactNom = this.contactNom() ? this.contactNom() : ''
      this.form.contactEmail = this.contactEmail()
      this.form.contactTel1 = this.contactTel1()
      this.form.contactTel2 = this.contactTel2()
      this.form.adresse = this.adresse()
      this.form.complementAdresse = this.complementAdresse()
      this.form.typeOperations = this.typeOperations().map(operation => operation.id)
      this.form.terrainOccupe = false
      this.form.etat = this.etat() === 1
      this.form.numeroAffaire = this.numeroAffaire()
    },
    openModal (idProject = null) {
      this.step = 1

      if (!this.editMode) {
        this.setDataOnForm()
        this.idProject = idProject
      }

      this.$refs['projectModalRef'].openModal()
    },
    hideModal () {
      this.$refs['projectModalRef'].closeModal()
    },
    handleNextStepAction () {
      this.$validator.validate().then(valid => {
        if (!valid) {
          // this.$toaster.error('Veuillez remplir les champs obligatoires')
          this.setMessage('Veuillez remplir les champs obligatoires')
          return
        }
        if (this.step === 1) {
          this.step = 2
          return
        }

        this.form.etat = this.form.etat ? 1 : 3
        if (this.editMode) {
          this.addProject(this.form).then(resp => {
            // this.$toaster.success('Projet créé')
            this.setMessage('Projet créé')
            this.$emit('afterSubmitForm', resp.id)
          }, err => {
            // this.$toaster.error(err)
            this.setMessage(err)
          })
          return
        }

        this.modificationProjet({ idProjet: this.idProject, form: this.form }).then(resp => {
          // this.$toaster.success('Modifié')
          this.setMessage('Modifié')
          this.$refs['projectModalRef'].closeModal()
          this.$emit('updateEvent')
        }, err => {
          // this.$toaster.error(err)
          this.setMessage(err)
        })
      })
    },
    handlePreviousStepAction () {
      this.step = 1
    },
    codePostalHandleChange (e) {
      if (this.form.codePostal.length >= 5) {
        this.form.codePostal = this.form.codePostal.slice(0, 5)
        if (this.form.codePostal.slice(0, 2) !== '97') {
          this.getDepartement(this.form.codePostal.slice(0, 2)).then((resp) => {
            if (resp[0]) {
              this.form.departement = resp[0].nom
              return
            }
            // this.$toaster.error('Code postal inéxistant')
            this.setMessage('Code postal inéxistant')
          })
          return
        }

        this.getDepartement(this.form.codePostal.slice(0, 3)).then((resp) => {
          if (resp[0]) {
            this.form.departement = resp[0].nom
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/editSteppedModal/index.vue